import { dev } from './dev'
import { local } from './local'
import { prd } from './prd'
import { stg } from './stg'
import type { SettingsTemplate } from './template'

export const ENV_KEYS = {
  dev: 'dev',
  stg: 'stg',
  prd: 'prd',
  local: 'local'
} as const

export type Stage = keyof typeof ENV_KEYS

// Maps any stage name to a known stage.
// Personal/dev names like "ale", "pedro", "chris" resolve to 'local'.
export function normalizeStage(stage: string): Stage {
  switch (stage) {
    case ENV_KEYS.dev:
    case ENV_KEYS.stg:
    case ENV_KEYS.prd:
      return stage
    default:
      return 'local'
  }
}

function pickStageSettings(stage: string): SettingsTemplate {
  switch (normalizeStage(stage)) {
    case 'dev':
      return dev
    case 'stg':
      return stg
    case 'prd':
      return prd
    default:
      return local
  }
}

// Ale (main dev) is the only personal stage with custom domains
// (`ale.gmi-character-playground.exp.monks.zone` + `api.ale....`).
// Other devs keep the normal flow: localhost via `npm run dev` or raw CloudFront URLs via deploy.
function applyPersonalStageOverrides(settings: SettingsTemplate, stage: string): SettingsTemplate {
  if (stage !== 'ale') return settings

  return {
    ...settings,
    ENABLE_CUSTOM_DOMAIN: true
  }
}

export function getSettingVariables(stage: string): SettingsTemplate {
  return applyPersonalStageOverrides(pickStageSettings(stage), stage)
}

export { HOSTED_ZONE_NAME, settingsTemplate } from './template'
export type { SettingsTemplate }
